function replaceArray(string, object) {
    return object.reduce(
        (original, [regexp, replace]) => original.replace(regexp, replace),
        string,
    );
}

const specialChars = [
    [/æ/g, 'ae'],
    [/ø/g, 'oe'],
    [/å/g, 'aa'],
    [/é/g, 'e'],
    [/è/g, 'e'],
    [/à/g, 'a'],
    [/ä/g, 'a'],
    [/ö/g, 'o'],
    [/õ/g, 'o'],
];

const nonAlphaNumeric = /[^A-Za-z0-9]+/g;

export default function urlFriendly(string) {
    if (typeof string !== 'string') {
        throw new Error("Can't url friendly a non string");
    }

    return replaceArray(string.toLowerCase(), specialChars)
        .replace(nonAlphaNumeric, '-')
        .replace(/(^([-]+)|([-]+)$)/g, ''); // Trim leading and trailing dashes
}



/** WEBPACK FOOTER **
 ** ./src/utils/url-friendly.js
 **/